<template>
  <div class="zgornji-odmik-poraba-dnevnik">
    <p class="open-sans-20pt">
      Dnevnik klicev
    </p>
    <div v-if="prikazTabele === '1'">
      <el-table :data="podseznamPodatkov" v-loading="nalaganjeVsebine" width="100%">
        <el-table-column prop="date"
                         label="Čas klica">
          <template slot-scope="scope">
            {{ scope.row.formatDatuma }}
          </template>
        </el-table-column>
        <el-table-column label="Številka">
          <template slot-scope="scope">
            <span v-show="scope.row.callee > 0">
              {{ scope.row.callee }}
            </span>
            <span v-show="scope.row.caller > 0">
              {{ scope.row.caller }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="actualDuration" label="Trajanje (v sek.)">
        </el-table-column>
        <el-table-column prop="pretvorbaZnesek" label="Znesek v € (z DDV)">
        </el-table-column>
        <el-table-column prop="description" label="Omrežje klicane številke" width="250px">
        </el-table-column>
        <el-table-column label="Smer klica" width="100px">
          <template slot-scope="scope">
            <div v-if="scope.row.callDirection === 'Dohodni'">
              <el-tooltip class="item" content="Dohodni" placement="right-start">
                <img class="velikost-dohodnih-izhodnih-klicev" :src="scope.row.callDirectionIcon">
              </el-tooltip>
            </div>
            <data v-else>
              <el-tooltip class="item" content="Odhodni" placement="right-start">
                <img class="velikost-dohodnih-izhodnih-klicev" :src="scope.row.callDirectionIcon">
              </el-tooltip>
            </data>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="prikazTabele === '0'">
      <el-table :data="podseznamPodatkov">
        <el-table-column>
          <template slot-scope="props">
            <p>
              <span>
                <b>
                  Čas klica:
                </b>
              </span>
              {{ props.row.formatDatuma }}
            </p>
            <p>
              <span v-show="props.row.callee > 0">
                <b>
                  Številka:
                </b>
                {{ props.row.callee }}
              </span>
              <span v-show="props.row.caller > 0">
                <b>
                  Številka:
                </b>
                {{ props.row.caller }}
              </span>
            </p>
            <p>
              <span>
                <b>
                  Trajanje (v sek.):
                </b>
              </span>
              {{ props.row.actualDuration }}
            </p>
            <p>
              <span>
                <b>
                  Znesek v € (z DDV):
                </b>
              </span>
              {{ props.row.pretvorbaZnesek }}
            </p>
            <p>
              <span>
                <b>
                  Omrežje klicane številke:
                </b>
              </span>
              {{ props.row.description }}
            </p>
            <p>
              <span>
                <b>
                  Smer klica:
                </b>
              </span>
              {{ props.row.callDirection }}
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center">
      <br/>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="PrikaziStran"
        :current-page="trenutnoIzbranaStran"
        :page-size="4"
        layout="prev, pager, next"
        :total="dolzinaSeznamaDnevnikKlicev"
        small>
      </el-pagination>
    </div>
    <div class="odmik-besedila">
      <p class="navadno-besedilo">
        Izpis klicev in porabe sta informativne narave. <br/>
        Cene v Evrih so natančne do četrte decimalke. Obračunski interval je 60/1. Naročniku se prvih 60 sekund
        klica obračuna v celoti ne glede na dolžino klica, nadalje pa se klici obračunajo po sekundnem
        intervalu. Obračunski interval govorne telefonije v mednarodnem gostovanju (ROAM) je 1 minuta, razen
        za države Evropske Unije, kjer so klici obračunani po sekundnem intervalu po začetnem 30-sekundnem
        intervalu. <br/>
        Cenik veljaven za klice od 01.07.2009, ogledati si ga lahko na
        <a :href="cenaKlicev" class="primarna-barva" target="_blank">
          www.t-2.net/cenik-mobilna-telefonija
        </a>
      </p>
    </div>
    <div v-if="seznamRazdeljenihZgresenihKlicev.length > 0">
      <div class="odmik-hr">
        <hr class="hr-stil"/>
      </div>
      <p class="open-sans-20pt">
        Zgrešeni klici (za preteklih 20 dni)
      </p>
      <div v-show="prikazTabele === '1'">
        <div>
          <el-table :data="seznamRazdeljenihZgresenihKlicev" empty-text="Ni podatkov">
            <el-table-column prop="number" label="Številke" width="400px">
            </el-table-column>
            <el-table-column prop="time" label="Čas klica">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-show="prikazTabele === '0'">
        <div>
          <el-table :data="seznamRazdeljenihZgresenihKlicev" empty-text="Ni podatkov">
            <el-table-column>
              <template slot-scope="props">
                <p>
                <span>
                  <b>
                    Telefonska številka :
                  </b>
                </span>
                  {{ props.row.number }}
                </p>
                <p>
                <span>
                  <b>
                    Čas klica :
                  </b>
                </span>
                  {{ props.row.time }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-center">
        <br/>
        <el-pagination
          :hide-on-single-page="true"
          @current-change="PrikazStraniZgreseniKlici"
          :current-page="trenutnoIzbranaStranZgresenihKlicev"
          :page-size="4"
          layout="prev, pager, next"
          :total="dolzinaSeznamaZgresenihKlicev"
          small>
        </el-pagination>
      </div>
    </div>
    <br/>
    <div class="postavitev-izvoza-klicev">
      <el-button class="gumb-potrdi">
        <download-excel
          :data="seznamKlicevZaIzpis"
          :fields="jsonFieldsPosameznaStevilka"
          worksheet="Dnevnik vseh stevilk"
          name="Izpis_vseh_stevilk.xls">
          <img src="../../../../../../static/img/Icon/PorabaTelefonija/Icon-file-excel-regular.png">
          IZVOZ DNEVNIK KLICEV
        </download-excel>
      </el-button>
    </div>
    <span class="opozorilo">
      <el-icon class="el-icon-info" style="padding-top:5px">
      </el-icon>
      <span class="opozorilo-mobile">
        Izpis dnevnika klicev je informativne narave, zgodovino dogodkov beležimo za zadnje 3 mesece.
      </span>
    </span>
  </div>
</template>
<script>
import Vue from 'vue'
import {povezave} from './../../../../../assets/js/Povezave/povezave'
import {Checkbox, Button, Select, Option, Card, Table, TableColumn, Tooltip} from 'element-ui'
import {ObdelavaDatuma} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/IzbiraMeseca.js'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import JsonExcel from 'vue-json-excel'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'

Vue.component('downloadExcel', JsonExcel)
export default {
  name: 'porabatelefonija',
  mixins: [PrikazVsebine, ObdelavaDatuma, FormatDatuma],
  components: {
    ObdelavaDatuma,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip
  },
  data () {
    return {
      clientAgent: null,
      seznamKlicev: [],
      nalaganjeVsebine: false,
      izpisZakupljenihEnot: true,
      podatkiZakupljenihEnot: [],
      podseznamPodatkov: [],
      seznamRazdeljenihZgresenihKlicev: [],
      seznamKlicevZaIzpis: [],
      dolzinaSeznamaDnevnikKlicev: null,
      dolzinaSeznamaZgresenihKlicev: null,
      trenutnoIzbranaStran: 1,
      trenutnoIzbranaStranZgresenihKlicev: 1,
      seznamZgresenihKlicev: [],
      cenaKlicev: '',
      jsonFieldsPosameznaStevilka: {
        'Čas klica': 'date',
        'Številka': 'klicoceStevilke',
        'Trajanje (v sek.)': 'actualDuration',
        'Znesek v € (z DDV)': 'pretvorbaZnesek',
        'Omrežje klicane številke': 'description',
        'Smer klica': 'callDirection'
      },
      json_meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ]
    }
  },
  props: {
    izbranSap: null,
    telefonskaStevilka: '',
    izbranMesec: '',
    izbranid: '',
    idStroskovniNosilec: '',
    idPrikljucek: ''
  },
  watch: {
    izbranSap: function () {
      if (this.izbranSap !== '') {
        this.telefonskaStevilka = ''
        this.GetPorabaInfo()
      }
    },
    telefonskaStevilka: function () {
      if (this.telefonskaStevilka !== '') {
        this.GetPorabaInfo()
      }
    },
    izbranMesec: function () {
      if (this.izbranMesec !== '') {
        this.GetPorabaInfo()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.DolociIzbranMesec()
    this.GetPorabaInfo()
    this.cenaKlicev = povezave.BASE_URL_CENA_KLICEV
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    GetPorabaInfo () {
      if (this.izbranSap !== '') {
        if (this.telefonskaStevilka !== null && this.telefonskaStevilka !== '') {
          this.nalaganjeVsebine = true
          this.seznamRazdeljenihZgresenihKlicev = []
          let izbranoObdobje = this.DolociIzbranMesec()
          let param = ['telefonskaStevilka=' + this.telefonskaStevilka]
          param.push('datumOd=' + izbranoObdobje.trajanjeOd)
          param.push('datumDo=' + izbranoObdobje.trajanjeDo)
          param.push('izpisZakuplenihEnot=' + this.izpisZakupljenihEnot)
          this.clientAgent.postWsRequest(
            this,
            'mercury/poraba',
            param,
            null,
            'SetPorabaInfo',
            'ErrPorabaInfo')
        }
      }
    },
    SetPorabaInfo (podatki) {
      this.davek = ''
      if (typeof podatki.details !== 'undefined' && podatki.details !== null && typeof podatki.details.voice !==
        'undefined' && podatki.details.voice !== null && podatki.details.voice.length > 0) {
        if (typeof podatki.missedCalls !== 'undefined' && podatki.missedCalls !== null) {
          this.seznamZgresenihKlicev = []
          for (let i = 0; i < podatki.missedCalls.length; i++) {
            let formatDatuma = this.PoenotenIzgledDatuma(podatki.missedCalls[i].date)
            Vue.set(podatki.missedCalls[i], 'formatDatuma', formatDatuma)
            this.seznamZgresenihKlicev.push(podatki.missedCalls[i])
          }
          let tmpArrayZgreseniKlici = []
          this.dolzinaSeznamaZgresenihKlicev = this.seznamZgresenihKlicev.length
          const chunk = 4
          for (let i = 0; i < this.dolzinaSeznamaZgresenihKlicev; i += chunk) {
            tmpArrayZgreseniKlici.push(this.seznamZgresenihKlicev.slice(i, i + chunk))
          }
          this.seznamZgresenihKlicev = tmpArrayZgreseniKlici
          this.PrikazStraniZgreseniKlici(1)
        }
        this.seznamKlicev = []
        this.seznamKlicev = podatki.details.voice
        for (let i = 0; i < this.seznamKlicev.length; i++) {
          let formatDatuma = this.PoenotenIzgledDatuma(this.seznamKlicev[i].date)
          Vue.set(this.seznamKlicev[i], 'formatDatuma', formatDatuma)
          if (this.seznamKlicev[i].callDirection > 0) {
            this.seznamKlicev[i].callDirectionIcon = '/static/img/Icon/PorabaTelefonija/Icon-awesome-sign-out-alt.png'
            this.seznamKlicev[i].callDirection = 'Odhodni'
          } else {
            this.seznamKlicev[i].callDirectionIcon = '/static/img/Icon/PorabaTelefonija/Icon-awesome-sign-in-alt.png'
            this.seznamKlicev[i].callDirection = 'Dohodni'
          }
          this.davek = (100 + this.seznamKlicev[i].vat) / 100
          this.seznamKlicev[i].pretvorbaZnesek =
            (((this.seznamKlicev[i].amount * this.davek) / 100)
              .toFixed(4).replace('.', ',') + ' €')
        }
        this.seznamKlicevZaIzpis = []
        if (typeof this.seznamKlicev !== 'undefined' && this.seznamKlicev.length > 0 && this.seznamKlicev !== null) {
          this.seznamKlicevZaIzpis = this.seznamKlicev
          let tmpArray = []
          this.dolzinaSeznamaDnevnikKlicev = this.seznamKlicev.length
          const chunk = 4
          for (let i = 0; i < this.dolzinaSeznamaDnevnikKlicev; i += chunk) {
            tmpArray.push(this.seznamKlicev.slice(i, i + chunk))
          }
          this.seznamKlicev = tmpArray
          this.PrikaziStran(1)
        }
      } else {
        this.seznamKlicev = []
        this.seznamZgresenihKlicev = []
        this.dolzinaSeznamaDnevnikKlicev = 0
        this.dolzinaSeznamaZgresenihKlicev = 0
        this.PrikaziStran(1)
        this.PrikazStraniZgreseniKlici(1)
      }
      if (podatki.units !== null && typeof podatki.units.dataBalance !== 'undefined' && podatki.units.dataBalance.length > 0) {
        this.podatkiZakupljenihEnot = podatki.units.dataBalance
      }
      this.nalaganjeVsebine = false
    },
    PrikazStraniZgreseniKlici (stran) {
      this.trenutnoIzbranaStranZgresenihKlicev = stran
      if (typeof this.seznamZgresenihKlicev[this.trenutnoIzbranaStranZgresenihKlicev - 1] !== 'undefined') {
        this.seznamRazdeljenihZgresenihKlicev = this.seznamZgresenihKlicev[this.trenutnoIzbranaStranZgresenihKlicev - 1]
      } else {
        this.seznamRazdeljenihZgresenihKlicev = this.seznamZgresenihKlicev
      }
    },
    ErrPorabaSap (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeVsebine = false
    },
    ErrPorabaInfo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.nalaganjeVsebine = false
    },
    PrikaziStran (stran) {
      this.trenutnoIzbranaStran = stran
      if (typeof this.seznamKlicev[this.trenutnoIzbranaStran - 1] !== 'undefined') {
        this.podseznamPodatkov = this.seznamKlicev[this.trenutnoIzbranaStran - 1]
        for (let i = 0; i < this.seznamKlicevZaIzpis.length; i++) {
          if (this.seznamKlicevZaIzpis[i].callee) {
            this.seznamKlicevZaIzpis[i].klicoceStevilke = this.seznamKlicevZaIzpis[i].callee
          } else if (this.seznamKlicevZaIzpis[i].caller) {
            this.seznamKlicevZaIzpis[i].klicoceStevilke = this.seznamKlicevZaIzpis[i].caller
          }
        }
      } else {
        this.podseznamPodatkov = []
      }
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Poraba/PorabaTelefonija/Dnevnik.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaTelefonija/Dnevnik.vue